import RegistrationFormPage from "./Create/RegistrationFormPage";
export { RegistrationFormPage };
export default RegistrationFormPage;
export { default as RegistrationForm } from "./Create/RegistrationForm";
export { default as LandingRegistrationPage } from "./LandingRegistrationPage";
export { default as RegistrationChangeFormPage } from "./Change/RegistrationChangeFormPage";
export { default as RegistrationCancelFormPage } from "./Cancel/RegistrationCancelFormPage";
export { default as RegistrationSuccessPage } from "./Success/RegistrationSuccessPage";
